module.exports = __webpack_public_path__ + "img/letter_door_back.14138ecc.png";